export const wishlistActions = {
  FETCH_WISHLISTS_SUCCESS: "FETCH_WISHLISTS_SUCCESS",
  FETCH_WISHLISTS_ERROR: "FETCH_WISHLISTS_ERROR",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  ADD_NEW_WISHLIST: "ADD_NEW_WISHLIST",
};

export function addNewWishlist(newWishlist) {
  return {
    type: wishlistActions.ADD_NEW_WISHLIST,
    payload: {
      newWishlist,
    },
  };
}

export function setWishlists(wishlists, hasNextPage) {
  return {
    type: wishlistActions.FETCH_WISHLISTS_SUCCESS,
    payload: {
      wishlists,
      hasNextPage,
    },
  };
}

export function setWishlistsError(error) {
  return {
    type: wishlistActions.FETCH_WISHLISTS_ERROR,
    payload: {
      error,
    },
  };
}

// color: to match w/ color from swatch carousel
// size: for delete scenarios -> we need to determine the messaging based on
// single size or multiple sizes
export function addToWishlist({
  type,
  wishlistId,
  sku,
  productId,
  color,
  size,
  styleOption,
}) {
  return {
    type: wishlistActions.ADD_TO_WISHLIST,
    payload: {
      type,
      wishlistId,
      sku,
      productId,
      color,
      size,
      styleOption,
    },
  };
}

export function removeFromWishlist(wishlistId, id) {
  return {
    type: wishlistActions.REMOVE_FROM_WISHLIST,
    payload: {
      wishlistId,
      id,
    },
  };
}
